<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<p v-if="page.bookingID">
						<a class="button cta" :href="page.bookingID" target="_blank">
							<span>{{ defaults[locale].packages.book }}</span>
						</a>
					</p>
					<p v-else>
						<book-button class="button cta">
							<span>{{ defaults[locale].packages.book }}</span>
						</book-button>
					</p>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</template>
		</main-content>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();
</script>
